import React, { useEffect, useRef, useState } from "react";
import Form from "../../components/forms/utils/Form";
import SingleLineField from "../../components/forms/SingleLineField";
import { useMutation } from "@apollo/client";
import { UPDATE_PUBLICATION_QUERY } from "../../utils/api-utils";
import { useFormContext } from "react-hook-form";
import { optionalHttpsUrlRule } from "../../utils/validators";

interface SelfHostedArticleProps {
  publication: any;
}

const eventName = "contimo:trackAdvertorial:";

const UrlField = () => {
  const form = useFormContext();
  const { watch } = form;

  const url = watch("url");

  useEffect(() => {
    const handleMessage = (event: any) => {
      const data = event.data;

      if (typeof data === "string" && data.includes(eventName)) {
        const parsedData = JSON.parse(data.replace(eventName, ""));
        form.setValue("cmsArticleId", parsedData.cmsArticleId);
      }
    };

    window.addEventListener("message", handleMessage, false);

    return () => window.removeEventListener("message", handleMessage, false);
  }, [form]);

  return (
    <>
      <SingleLineField
        label="URL"
        htmlfor="url"
        className="max-w-full sm:max-w-full"
        top
        rules={{ validate: { format: optionalHttpsUrlRule } }}
      />

      <iframe src={url} title="iframe" className="hidden" />
    </>
  );
};
const SelfHostedArticle: React.FC<SelfHostedArticleProps> = ({
  publication,
}) => {
  const [updatePublication] = useMutation(UPDATE_PUBLICATION_QUERY);
  useEffect(() => {}, []);

  const handleUpdatePublication = async (
    id: string,
    { __typename, ...selfHostedContent }: any
  ) => {
    updatePublication({
      variables: { id, record: { selfHostedContent, isSelfHosted: true } },
    });
  };
  return (
    <Form
      className="flex-1 relative bg-white rounded-md px-4 py-4 mb-10 sm:space-y-5"
      submitButtonText="Save"
      defaultValues={publication.selfHostedContent}
      onSubmit={(values) => handleUpdatePublication(publication._id, values)}
    >
      <UrlField />
      <SingleLineField
        label="CMS Article Id"
        htmlfor="cmsArticleId"
        className="max-w-full sm:max-w-full"
        top
      />
    </Form>
  );
};

export default SelfHostedArticle;
